import clsx from 'clsx';
import { FC } from 'react';
import { Link } from 'src/general/components/Link/Link';
import { FilterItemProps, PlpFiltersConditionalProps } from 'src/plp/components/PlpFilters/PlpFilters.type';
import styles from './FilterOptionField.module.scss';

type Props = Prettify<
  FilterItemProps & {
    checked: boolean;
    indeterminate?: boolean;
  } & PlpFiltersConditionalProps
>;

const getTestId = (slug: string, type: 'sidebar' | 'modal') => {
  const prefix = type === 'sidebar' ? 'filter-make' : 'filter-make-expand';
  return `${prefix}-${slug.toLowerCase()}`;
};

const getCheckboxTestId = (type: 'sidebar' | 'modal', slug?: string) => {
  if (type === 'sidebar') {
    return 'filter-checkbox';
  }
  return slug ? `filter-checkbox-${slug.toLowerCase()}` : 'filter-checkbox-mobile';
};

const getMakeModelTestId = (type: 'sidebar' | 'modal', slug: string) => {
  if (type === 'sidebar') {
    return `desktop-makeModel-${slug.toLowerCase()}`;
  }
  return `modal-makeModel-${slug.toLowerCase()}`;
};

export const FilterOptionField: FC<Props> = ({
  slug,
  value,
  filter,
  href,
  nofollow,
  checked,
  indeterminate,
  label,
  ...props
}) => {
  return props.type === 'sidebar' ? (
    <Link
      href={href ?? ''}
      rel={nofollow ? 'nofollow' : undefined}
      className={styles.link}
      data-testid={getTestId(slug, 'sidebar')}
    >
      <label className={clsx(styles.contentWrapper, styles.start, { checked, indeterminate }, 'labelWrapper')}>
        <div className={clsx(styles.inputWrapper, 'inputWrapper')}>
          <div
            className={clsx('visualCheckbox', styles.checkbox, {
              [styles.checked]: checked,
              [styles.indeterminate]: indeterminate,
            })}
            data-testid={getCheckboxTestId('sidebar')}
          />
        </div>
        <div className={clsx(styles.content, 'label')} data-testid={`filter-model`}>
          {label}
        </div>
      </label>
    </Link>
  ) : (
    <label
      className={clsx(styles.contentWrapper, styles.start, { checked, indeterminate }, 'labelWrapper')}
      data-testid={getMakeModelTestId(props.type, slug)}
    >
      <div className={clsx(styles.inputWrapper, 'inputWrapper')}>
        <input
          type={'checkbox'}
          className={styles.input}
          checked={checked}
          data-indeterminate={indeterminate}
          data-testid="filter-checkbox"
          onChange={() => {
            props.onSelectFilter({
              slug,
              value,
              filter,
            });
          }}
        />
        <div
          className={clsx('visualCheckbox', styles.checkbox, {
            [styles.checked]: checked,
            [styles.indeterminate]: indeterminate,
          })}
          data-testid={getCheckboxTestId('modal', slug)}
        />
      </div>
      <div className={clsx(styles.content, 'label')} data-testid={`filter-model`}>
        {label}
      </div>
    </label>
  );
};
